import { formatText } from "@ui/format";
import { MONTHS_HUN_SHORT } from "bm-ui-kit";
import dayjs from "dayjs";
import type { ColorType, Point } from "highcharts";
import type { BarometerJsonDataPath } from "./Barometer.types";

export const baseDataPath = "https://reports.bankmonitor.hu/api/v1/mortgage/barometer/";
export const dataPaths: BarometerJsonDataPath[] = [
	{
		type: "history",
		category: "high",
		url: "high/high_history.json",
	},
	{
		type: "calculated",
		category: "high",
		url: "high/high_calculated.json",
	},
	{
		type: "history",
		category: "medium",
		url: "medium/medium_history.json",
	},
	{
		type: "calculated",
		category: "medium",
		url: "medium/medium_calculated.json",
	},
	{
		type: "history",
		category: "low",
		url: "low/low_history.json",
	},
	{
		type: "calculated",
		category: "low",
		url: "low/low_calculated.json",
	},
];

const renderTooltipData = (name: string, value: number, color: ColorType) => {
	const style =
		typeof color === "string" ? `border-left: 4px solid ${color}; padding-left: 3px; margin-top: 4px` : "";
	return `<div style="${style}">${name}<br/><strong>${formatText(value, "%")}</strong></div>`;
};
export const chartBaseOptions: Highcharts.Options = {
	credits: {
		enabled: false,
	},
	title: {
		text: null,
	},
	chart: {
		type: "line",
	},
	legend: {
		enabled: false,
	},
	xAxis: {
		crosshair: true,
		type: "datetime",
		tickInterval: 24 * 3600 * 1000 * 28 * 2,
		labels: {
			rotation: -45,
			formatter(this) {
				const date = dayjs(this.value);
				return `${date.year()} ${MONTHS_HUN_SHORT[date.month()]}`;
			},
		},
	},
	yAxis: {
		title: {
			text: undefined,
		},
		labels: {
			formatter(this) {
				return formatText(this.value, "0.00%");
			},
		},
	},
	tooltip: {
		enabled: true,
		useHTML: true,

		formatter(this: Point) {
			const series1 = this.series.chart.series[0];
			const series2 = this.series.chart.series[1];
			const y1 = series1.data[this.index]?.y;
			const y2 = series2.data[this.index]?.y;
			const tooltipHeader = `<span class="small">${dayjs(this.x).format("YYYY.MM.DD.")}</span>`;

			return [
				tooltipHeader,
				renderTooltipData(series2.name, y2, series2.color),
				renderTooltipData(series1.name, y1, series1.color),
			].join("");
		},
	},
};
